import { render, staticRenderFns } from "./AddPayToMandatePage.vue?vue&type=template&id=ceac86fe&"
import script from "./AddPayToMandatePage.vue?vue&type=script&lang=ts&"
export * from "./AddPayToMandatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports